import { atom, useAtomValue, useSetAtom } from "jotai";
import { ModalSize } from "rizzui";

type ModalTypes = {
    view: React.ReactNode;
    isOpen: boolean;
    customSize?: string;
    className?: string;
    containerClassName?: string;
    size?: ModalSize;
};

const modalAtom = atom<ModalTypes>({
    isOpen: false,
    view: null,
    customSize: "320px",
    size: "sm",
    className: undefined,
    containerClassName: undefined,
});

export function useModal() {
    const state = useAtomValue(modalAtom);
    const setState = useSetAtom(modalAtom);

    const openModal = ({
        view,
        customSize,
        size,
        className,
        containerClassName,
    }: {
        view: React.ReactNode;
        customSize?: string;
        className?: string;
        containerClassName?: string;
        size?: ModalSize;
    }) => {
        setState({
            ...state,
            isOpen: true,
            view,
            customSize,
            className,
            containerClassName,
            size,
        });
    };

    const closeModal = () => {
        setState({
            ...state,
            isOpen: false,
        });
    };

    return {
        ...state,
        openModal,
        closeModal,
    };
}
